import { useMemo } from 'react';
import { useHistory } from 'react-router';

export const usePredefinedFilters = ({ predefinedFilters }) => {
  const history = useHistory();
  return useMemo(() => {
    const combinedFilters = [...(history?.location?.state?.predefinedFilters ?? [])];

    if (predefinedFilters != null) {
      combinedFilters.push(...predefinedFilters);
    }

    return combinedFilters;
  }, [history?.location?.state?.predefinedFilters, predefinedFilters]);
};
